import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMyv: CultureInfo = {
  name: 'myv',
  displayName: 'эрзянь кель',
  iso3LanguageCode: 'myv',
  iso2LanguageCode: 'myv',
  ietfLanguageTag: 'myv',
  parent: null
};
